"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _web3Utils = require("web3-utils");

var _FDSContract = _interopRequireDefault(require("./FDS-Contract"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

class Tx {
  constructor(config, account) {
    this.account = account;
    this.config = config;
    this.web3 = this.config.web3;
  }

  getContract(account, abi, address) {
    var c = new _FDSContract.default(this.config, account, abi);
    return c.at(address);
  }

  deployContract(account, abi, bytecode) {
    var args = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var c = new _FDSContract.default(this.config, account, abi, bytecode);
    return c.deploy(args);
  }

  syncNonce(account) {
    return this.web3.eth.getTransactionCount(account.wallet.address);
  }
  /**
   *
   * @param {any} account to send from
   * @param {any} toAddress 0xfff
   * @param {any} amount in wei
   * @param {any} transactionCallback callback
   * @param {any} transactionSignedCallback callback
   * @returns {any} transaction
   */


  pay(account, toAddress, amount) {
    var _this = this;

    var gas = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 6000000;
    var transactionCallback = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : console.log;
    var transactionSignedCallback = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : console.log;
    return new Promise( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* (resolve, reject) {
        var currentGas = yield _this.web3.eth.getGasPrice();
        var requiredGasPrice = yield _this.web3.eth.estimateGas({
          to: toAddress
        });
        var gas = currentGas * requiredGasPrice;
        var value = parseInt(amount) - gas;
        var tx = {
          from: account.address,
          to: toAddress,
          gas: requiredGasPrice,
          gasPrice: currentGas,
          value: "".concat(value)
        };
        transactionCallback(tx);
        return _this.web3.eth.accounts.signTransaction(tx, account.privateKey).then(signed => {
          return _this.web3.eth.sendSignedTransaction(signed.rawTransaction).once('confirmation', function (i, hash) {
            resolve(hash);
          });
        });
      });

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
  }
  /**
   * Ensure address has enough balance
   * @getBalance
   * @param {string} address to check
   * @returns {void} balance of address
   */


  getBalance(address) {
    try {
      return this.web3.eth.getBalance(address);
    } catch (error) {
      console.error("can't access gateway ", config.ethGateway);
    }
  }

  getBlockNumber() {
    return this.web3.eth.getBlockNumber();
  }

  sign(account, message) {
    return this.web3.eth.accounts.sign(message, account.privateKey);
  }

  recover(message, sig) {
    return this.web3.eth.accounts.recover(message, sig);
  }

}

var _default = Tx;
exports.default = _default;
module.exports = exports.default;